import React, { useEffect, useState } from "react";
import PageHeader from "../components/PagesHeaderComponent/PageHeader";
import { Button, Card, Col, Container, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";
import { Sec7, Sec8 } from "../components/Homecomponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import PageHeaderWithRoutes from "../components/PagesHeaderComponent/PageHeaderWithRoute";
import DocIcon from "../../assets/images/icons/document_icon.png"
import WebinarIcon from "../../assets/images/icons/webinar_icon2.png"
import VideoIcon from "../../assets/images/icons/video_icon.png"
import FaqIcon from "../../assets/images/icons/faq_icon.png"
import DownloadIcon from "../../assets/images/icons/download.png"
import ReactPlayer from "react-player";
import InnerHeading from "../components/InnerHeading/InnerHeading";
import { Box, LinearProgress } from "@mui/material";
import CoreHttpHandler from "../../http/services/CoreHttpHandler";
import { Button as AntButton, Dropdown, Input, Menu, Pagination } from "antd";
import CustomTextLimit from "../../assets/global-components/TextLimit";

const Webinars = () => {

	const [webinars, setWebinars] = useState([]);
	const [allWebinars, setAllWebinars] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [modalShow, setModalShow] = useState(false);
	const [videoUrl, setVideoUrl] = useState("");
	const [searchTitle, setSearchTitle] = useState("");
	const [selectedOrder, setSelectedOrder] = useState("DESC");
	const pageSize = 6;

	const getWebinars = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"shareholder_rights",
			"fetchShareHolderRights",
			{
				"type": "webinar",
				"status": "true",
				"limit": 10000,
				"page": 1
			},
			(res) => {
				setAllWebinars(res.data.data.shareholderss.data)
				setIsLoading(false)
			},
			(err) => {
				setIsLoading(false)
			}
		);
	};

	const filterWebinars = () => {
		let filtered = allWebinars;

		if (searchTitle) {
			filtered = filtered.filter(web =>
				web.title?.toLowerCase().includes(searchTitle.toLowerCase())
			);
		}

		const sorted = [...filtered].sort((a, b) =>
			selectedOrder === "ASC"
				? a.id - b.id
				: b.id - a.id
		);

		setWebinars(sorted);
		setCurrentPage(1);
	};

	const handleOrderMenuClick = (e) => {
		setSelectedOrder(e.key);
	};

	const clearSearch = () => {
		setSearchTitle("");
		setSelectedOrder("DESC");
		setWebinars(allWebinars);
		setCurrentPage(1);
	};

	const orderMenu = (
		<Menu onClick={handleOrderMenuClick}>
			<Menu.Item key={"ASC"}>ASC</Menu.Item>
			<Menu.Item key={"DESC"}>DESC</Menu.Item>
		</Menu>
	);

	const paginatedWebinars = webinars.slice(
		(currentPage - 1) * pageSize,
		currentPage * pageSize
	);


	let headerData = [{
		name: " Your Rights",
		route: "/ShareHoldersRights/Documents",
		imgSrc: DocIcon
	}
		, {
		name: "Videos",
		route: "/ShareHoldersRights/Videos",
		imgSrc: VideoIcon
	}
		, {
		name: "Webinars",
		route: "/ShareHoldersRights/Webinars",
		imgSrc: WebinarIcon
	}
		, {
		name: "FAQs",
		route: "/ShareHoldersRights/Faqs",
		imgSrc: FaqIcon
	}
	]
	useEffect(() => {
		getWebinars();
	}, [])

	useEffect(() => {
		filterWebinars();
	}, [allWebinars])

	return (
		<>
			{/* <PageHeader heading="Webinars and Events" /> */}
			<PageHeaderWithRoutes tabs={headerData} heading="Shareholder Rights" desc="Stay informed about your rights as a shareholder and exercise your rights in the best interest of your role as a responsible shareholder!" />

			<div className="content_wrap">
				<section className='sec docs'>
					<div className='container'>
						<div className="cards_wrap">
							<Container>
								<Row>
									<InnerHeading heading="Webinars" text="Watch previously conducted insightful webinars focused on educating shareholders about their rights and how to exercise them effectively." />

									<Col xs={12} style={{ animation: "fadeInUp 0.5s ease both" }}>
										<Row className="d-flex align-items-center justify-content-center mb-4">
											<Col lg={5} md={5} xs={12} style={{ marginBottom: "10px" }}>
												<Input
													value={searchTitle}
													style={{ width: "100%", borderRadius: "20px", padding: "8px 15px", transition: "all 0.3s ease", border: "1px solid #d9d9d9" }}
													onFocus={(e) => e.target.style.boxShadow = "0 0 0 3px rgba(7,88,143,0.1)"}
													onBlur={(e) => e.target.style.boxShadow = "none"}
													onChange={(e) => setSearchTitle(e.target.value)}
													placeholder="Search by Title"
												/>
											</Col>
											<Col lg={2} md={2} xs={4} style={{ marginBottom: "10px" }}>
												<Dropdown overlay={orderMenu} trigger={['click']}>
													<AntButton
														style={{ width: "100%", borderRadius: "20px", padding: "0 15px", height: "36px", transition: "all 0.3s ease" }}
														onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; }}
														onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; }}
													>
														Sort: {selectedOrder} ▼
													</AntButton>
												</Dropdown>
											</Col>
											<Col lg={3} md={3} xs={8} style={{ marginBottom: "10px", display: "flex", gap: "8px" }}>
												<AntButton
													style={{ background: "#07588f", color: "#fff", border: "none", flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
													onMouseEnter={(e) => { e.currentTarget.style.background = "#0a6ebd"; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(7,88,143,0.3)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.background = "#07588f"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
													onClick={() => filterWebinars()}
												>
													Search
												</AntButton>
												<AntButton
													style={{ flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
													onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; e.currentTarget.style.transform = "translateY(-2px)"; }}
													onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; e.currentTarget.style.transform = "translateY(0)"; }}
													onClick={clearSearch}
												>
													Clear
												</AntButton>
											</Col>
										</Row>
									</Col>

									{isLoading ?
										<Box sx={{ my: '5rem' }}>
											<LinearProgress color="success" />
										</Box>
										:

										paginatedWebinars.map((e) => {
											return <>
												<Col lg={4} md={6}>
													<Card style={{ background: "#f2f5f7", margin: "10px", padding: "1.5em", borderRadius: "1em", minHeight: "450px", display: "flex", justifyContent: "space-between", flexDirection: "column" }}>
														<CustomTextLimit limit={50} title text={e.title} />
														<CustomTextLimit text={e.description} />
														<div style={{ position: 'relative', width: '100%', height: '200px' }}>
															<ReactPlayer
																url={e.url}
																width="100%"
																height="100%"
																config={{
																	youtube: {
																		playerVars: {
																			controls: 0,
																		},
																	},
																}}
															/>
															<div
																style={{
																	position: 'absolute',
																	top: 0,
																	left: 0,
																	width: '100%',
																	height: '100%',
																	backgroundColor: 'rgba(255, 255, 255, 0)',
																	cursor: 'not-allowed',
																}}
															/>
														</div>
														<button className="btnWebinar" disabled={!e.url} onClick={() => { setModalShow(true); setVideoUrl(e.url) }}>Watch Video</button>
													</Card>
												</Col>
											</>
										})

									}

								</Row>
							</Container>
							<Pagination
								total={webinars.length}
								current={currentPage}
								hideOnSinglePage
								pageSize={pageSize}
								onChange={(page) => setCurrentPage(page)} />


							<Modal backdrop="static"
								centered
								dialogClassName="modal-90w"
								keyboard={false}
								show={modalShow}
								onHide={() => setModalShow(false)}
								aria-labelledby="contained-modal-title-vcenter">
								<Modal.Header className="modal-bg" closeButton>
									<Modal.Title id="contained-modal-title-vcenter">
										Video
									</Modal.Title>
								</Modal.Header>
								<Modal.Body className="grid-example modal-bg">
									<Container>

										{/* <Row>
												<Col xs={12} md={12}> */}

										<ReactPlayer controls url={videoUrl} width="100%" style={{ minHeight: "60vh", maxHeight: "80vh" }} />

										{/* </Col>

												
											</Row> */}


									</Container>
								</Modal.Body>
							</Modal>



							{/* <video width="400px" src="https://www.youtube.com/watch?v=EngW7tLk6R8" /> */}

							{/* {data.map((e) => {
								return <>
									<Card className="cards">
										<h5>{e.title}</h5>
										<div className="card-content">
											<Button className="card_btn" variant="primary"><img src={DownloadIcon} /> ENG</Button>
											<Button className="card_btn" variant="primary"><img src={DownloadIcon} /> اردو</Button>
										</div>
									</Card>
								</>
							})} */}
						</div>
					</div>
				</section>


			</div>
		</>
	);
};

export default Webinars;
